/**
 * Single place for product identity. Renaming the product, moving the domain
 * or adding promo links to other projects only requires changing this file.
 * Plain constants only: the build also reads it (page metadata, robots.txt).
 */
export const BRAND = {
  name: 'Shycut',
  /** Canonical address, no trailing slash: links, social previews, sitemap. */
  url: 'https://shycut.com',
  /** Search results, social previews and the installed app (English is primary). */
  description:
    'Free, private video tool: blur faces and licence plates, cut silences, add captions and resize for Reels, TikTok and Shorts — all in your browser.',
  /** Social preview image, made by `npm run assets:og`. */
  socialImage: { path: '/og-image.jpg', width: 1200, height: 630 },
  /** Public contact address (privacy page, structured data, llms.txt). */
  email: 'hello@shycut.com',
  /** Square logo search engines show next to results (made by `npm run assets:icons`). */
  logo: { path: '/icons/icon-512.png', size: 512 },
  /** Shown in the footer; add links to your other products here. */
  promoLinks: [] as ReadonlyArray<{ readonly label: string; readonly href: string }>,
} as const;

/** Page title from a translated template (`meta.title`, with `{{name}}` for the product name). */
export const homeTitle = (template: string): string => template.replaceAll('{{name}}', BRAND.name);

/** Home page path per language: English (primary) at the root, Turkish under /tr/. */
export const LANGUAGE_PATHS = { en: '/', tr: '/tr/' } as const;
